<template>
  <v-tabs v-model="model" :centered="!device.isDesktop" grow>
    <v-tab
      v-show="
        selectedMenu.shiftOne &&
        Object.keys(selectedMenu.shiftOne).length &&
        company.shift_one
      "
      :disabled="shiftEnable != 'all' && shiftEnable != 'shiftOne'"
    >
      <span :class="device.isDesktop ? '' : 'body-1'" class="text-capitalize">
        {{ translate(getShiftName("shift_1") || $t("shift_one")) }}
      </span>
    </v-tab>
    <v-tab
      v-show="
        selectedMenu.shiftTwo &&
        Object.keys(selectedMenu.shiftTwo).length &&
        company.shift_two
      "
      :disabled="shiftEnable != 'all' && shiftEnable != 'shiftTwo'"
    >
      <span :class="device.isDesktop ? '' : 'body-1'" class="text-capitalize">
        {{ translate(getShiftName("shift_2") || $t("shift_two")) }}
      </span>
    </v-tab>
    <v-tab
      v-show="
        selectedMenu.shiftThree &&
        Object.keys(selectedMenu.shiftThree).length &&
        company.shift_three
      "
      :disabled="shiftEnable != 'all' && shiftEnable != 'shiftThree'"
    >
      <span :class="device.isDesktop ? '' : 'body-1'" class="text-capitalize">
        {{ translate(getShiftName("shift_3") || $t("shift_three")) }}
      </span>
    </v-tab>
    <v-tab
      v-show="
        selectedMenu.shiftFour &&
        Object.keys(selectedMenu.shiftFour).length &&
        company.shift_four
      "
      :disabled="shiftEnable != 'all' && shiftEnable != 'shiftFour'"
    >
      <span :class="device.isDesktop ? '' : 'body-1'" class="text-capitalize">
        {{ translate(getShiftName("shift_4") || $t("shift_four")) }}
      </span>
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
    selectedMenu: {
      type: Object,
      required: true,
    },
    shiftEnable: {
      type: String,
      required: true,
    },
  },
  methods: {
    getShiftName(shift) {
      const translation = (this.company.shift_translations || []).find((st) => {
        return (
          st.shift_code === shift && st.language_code === this.$i18n.locale
        );
      });
      return translation?.label;
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit("input", value);
      },
      deep: true,
    },
    company() {
      return this.$store.state.company;
    },
  },
};
</script>
